import { Link } from "react-router-dom";
import styled from "styled-components"
import Theme from "../../../theme";




export const DashboardLink = styled(Link).attrs(() => ({
  className: "bottom-nav-link icon-home text-center",
  to: "/blogs"
}))`
color: ${props => props.location !== "/blogs" ? "black" : Theme.colorPrimary};

 &:visited {
    color: ${props => props.location === "/blogs" ? Theme.colorPrimary : "black"};
  }
`;

export const CctvLink = styled(Link).attrs(() => ({
  className: "bottom-nav-link icon-video text-center",
  to: "/cctv"
}))`
color: ${props => props.location !== "/cctv" ? "black" : Theme.colorPrimary};

  &:visited {
    color: ${props => props.location === "/cctv" ? Theme.colorPrimary : "black"};
  }
`;


export const MiddleLink = styled(Link).attrs(() => ({
  className: "middle-link bg-white",
  to: "/timeline"
}))`
background-image: url(${props => props.img}), url(${props => props.errorImg});
background-size: cover;
background-position: center;
box-shadow: ${props => props.location !== "/timeline"
    ? "0px 0px 0px 5px rgba(0, 0, 0, 0.3)"
    : `0px 0px 0px 5px ${Theme.colorPrimary}`
  };
`;

export const GalleryLink = styled(Link).attrs(() => ({
  className: "bottom-nav-link icon-photo-gallery-2 text-center",
  to: "/photoGallery"
}))`
color: ${props => props.location !== "/photoGallery" ? "black" : Theme.colorPrimary};
  &:visited {
    color: ${props => props.location === "/photoGallery" ? Theme.colorPrimary : "black"};
  }
`;

export const SupportLink = styled(Link).attrs(() => ({
  className: "bottom-nav-link icon-support text-center",
  to: "/support"
}))`
color: ${props => props.location !== "/support" ? "black" : Theme.colorPrimary};
&:visited {
    color: ${props => props.location === "/support" ? Theme.colorPrimary : "black"};
  }
`;
